import decorationOverridesRules from '~/constants/DecorationOverrides';

const searchForMaterial = (productMaterialText, materials) => {
  if (!productMaterialText) {
    return false;
  }
  const materialTextLowercaseWords = productMaterialText
    .toLowerCase()
    .split(/\s+/);

  return materials.some(m => materialTextLowercaseWords.includes(m));
};

const searchForDecorationMethod = (
  productDecorationMethod,
  decorationMethods
) => {
  if (!productDecorationMethod) {
    return false;
  }

  return decorationMethods.some(d => productDecorationMethod === d);
};

export const matchesDecorationOverride = (
  productId,
  decorationMethod,
  materialsText
) => {
  return decorationOverridesRules.find(rule => {
    if (rule.styleIds.length > 0 && rule.styleIds.includes(Number(productId))) {
      return true;
    }
    const materialMatch = searchForMaterial(materialsText, rule.materials);
    const decorationMethodMatch = searchForDecorationMethod(
      decorationMethod,
      rule.decorationMethods
    );

    if (materialMatch && decorationMethodMatch) {
      return true;
    }

    return (
      rule.materials.length === 0 &&
      rule.styleIds.length === 0 &&
      decorationMethodMatch
    );
  });
};

export const isColorPaletteRestricted = (
  isAnchorLaserEngraved,
  isDecorationOverridesEnabled,
  decorationOverride
) => {
  return (
    isAnchorLaserEngraved ||
    (isDecorationOverridesEnabled && decorationOverride?.restrictColorPalette)
  );
};
